import React from 'react';
import Post, { IPost } from './post';
import { LiveblogTenant } from '../../typings/liveblog-themes';
import { AcceptedCookiesConfig } from '../liveblog/liveblog';
import PostSlim from '../post-slim/post-slim';
import PinnedPost from '../pinned-post/pinned-post';

export const renderPostComponent = ({
  liveblogUrl,
  post,
  dateNow,
  hasReadmore,
  acceptedCookiesConfig,
  tenant,
  isSlimTimeline,
  isWebView,
}: {
  liveblogUrl?: string;
  post: IPost;
  dateNow: Date;
  hasReadmore?: boolean;
  acceptedCookiesConfig?: AcceptedCookiesConfig;
  tenant: LiveblogTenant;
  isSlimTimeline?: boolean;
  isWebView?: boolean;
}): JSX.Element => {
  switch (true) {
    case isSlimTimeline:
      return (
        <PostSlim
          tenant={tenant}
          href={liveblogUrl}
          postId={post.postId}
          title={post.title as string}
          dateNow={dateNow}
          timestamp={post.timestamp}
          timestampUtcIt={post.timestampUtcIt}
        />
      );
    case hasReadmore:
      return (
        <PinnedPost
          {...post}
          dateNow={dateNow}
          acceptedCookiesConfig={acceptedCookiesConfig}
          tenant={tenant}
          isWebView={isWebView}
        />
      );
    default:
      return (
        <Post
          {...post}
          dateNow={dateNow}
          acceptedCookiesConfig={acceptedCookiesConfig}
          tenant={tenant}
          isWebView={isWebView}
        />
      );
  }
};
